
export default {
  mapForm: {
    placesAndDirections: 'Suche & Los',
    isochrones: 'Erreichbarkeit',
    uploadedContentRendered: 'Importierter Inhalt bereit',
    errorRenderingContentUploaded: 'Fehler beim anzeigen des hochgeladenen Objekts. Bitte Format und Inhalt überprüfen.'
  }
}
